import { render, staticRenderFns } from "./crowd-crossline.vue?vue&type=template&id=97348b00&"
import script from "./crowd-crossline.vue?vue&type=script&lang=ts&"
export * from "./crowd-crossline.vue?vue&type=script&lang=ts&"
import style0 from "./crowd-crossline.vue?vue&type=style&index=0&id=97348b00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports